import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class UtilitiesLocations extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = 'UtilitiesLocations'

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return data
  }

  // eslint-disable-next-line no-unused-vars
  static async setupInstance(data, { models, store }) {
    if (!data.country_code) return data

    const a1 = await store.dispatch("utilities-lookup-zip/get", data.country_code)
    if (a1) data.format = a1

    store.state.base.address_countries.push(data)

    store.state.base.address_countries = store.state.base.address_countries.filter((country, index, self) =>
      index === self.findIndex(obj => obj.country_code === country.country_code))

    console.log("store.state.base.address_countries", store.state.base.address_countries);


    // use this for transforming your data, e.g. transform a Date-string into a Date object; see: https://vuex.feathersjs.com/model-classes.html#setupinstance
    return data;
  }
}
